<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">
        <h1 class="text-center">
          Create New Competition for {{ details.clearance_organization }}
        </h1>
      </b-col>
    </b-row>
    <b-row>
      <b-modal
        id="modal-leave"
        centered
        title="Confirm Exit"
        ok
        ok-variant="danger"
        cancel-variant="success"
        @ok="leaveRoute"
        @cancel="stayRoute"
      >
        <template v-slot:modal-ok> Leave </template>
        <p>Are You sure you want to leave. You may loose unsaved changes.</p>
      </b-modal>
      <b-col class="m-0 p-0">
        <form @submit.prevent="setCompetition">
          <b-overlay :show="sent" rounded="sm">
            <b-card bg-variant="light" class="m-0 p-0">
              <b-form-group class="mb-0">
                <div v-if="uploaded" class="alert alert-success p-3">
                  Competition Created
                </div>

                <b-form-group label="Competition Title">
                  <b-form-input
                    v-model="testspace.title"
                    placeholder="Competition Title"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Select Competition category" label-for="category">
                  <b-form-select
                    id="category"
                    :options="categoryarr"
                    v-model="testspace.category"
                    @change="chgcategory"
                    required
                  >
                    <b-form-select-option value="null"
                      >--Select category--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  v-if="testspace.category != null && sameName != 'Yes'"
                  label="Select Competition Institution"
                  label-for="selectinstitution"
                >
                  <b-form-select
                    id="selectinstitution"
                    class="form-inp"
                    :options="institutionsarr"
                    v-model="testspace.institution"
                    @change="chgInstitution"
                    required
                  >
                    <b-form-select-option value="null"
                      >--Select Institution--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="
                    testspace.structure == 'Section' &&
                      testspace.institution != null
                  "
                  label="Select Competition Level"
                  label-for="institution"
                >
                  <b-form-select
                    v-model="testspace.level"
                    @change="chgcourses"
                    :options="levelarr"
                  >
                    <b-form-select-option v-if="plan != 'Premium'" value="null"
                      >--Select Level--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="
                    testspace.structure == 'Section' &&
                      testspace.institution != null &&
                      testspace.level != null
                  "
                  label="Select Competition Course"
                  label-for="institution"
                >
                  <b-form-select
                    v-model="testspace.course"
                    @change="chgsection"
                    :options="coursesarr"
                  >
                    <b-form-select-option value="null"
                      >--Select Course--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  id="selsub"
                  label=""
                  label-size="lg"
                  class="nested-form-group"
                  v-if="
                    testspace.structure == 'Subject' &&
                      testspace.institution != null
                  "
                >
                  <!-- <h5>Select Subject Combination (Maximum of {{ numberofSubjects }})</h5> -->
                  <span
                    >Please select the Subjects to be written in this Test
                    Space</span
                  >
                  <b-form-checkbox-group
                    id="selectsubject"
                    v-model="testspace.subjects"
                    :options="subjectsarr"
                    name="subjectspo"
                    stacked
                    :state="substate"
                  >
                    <b-form-invalid-feedback :state="substate"
                      >Please Select exactly {{ numberofSubjects }} subject(s)
                      to Proceed</b-form-invalid-feedback
                    >
                    <b-form-valid-feedback :state="substate"
                      >{{ testspace.subjects.length }} Subject(s) Selected Successfully,
                      Proceed.</b-form-valid-feedback
                    >
                  </b-form-checkbox-group>
                </b-form-group>

                <b-form-group label="Competition Status" v-slot="{ ariaDescribedby }">
                  <span class="info-span"
                    >*Competition Status is used to check whether the Competition can be taken
                    by a User or not</span
                  ><br />
                  <span class="info-span"
                    >*When Competition status is set to Close, the User can see the
                    Competition but cannot Take the Test</span
                  >
                  <b-form-radio
                    v-model="testspace.status"
                    :aria-describedby="ariaDescribedby"
                    name="status"
                    value="Open"
                    >Open</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.status"
                    :aria-describedby="ariaDescribedby"
                    name="status"
                    value="Closed"
                    >Closed</b-form-radio
                  >
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  label="Competition Frequency"
                  label-for="testmode"
                >
                  <span class="info-span"
                    >*Competition Frequency is the amount of times a User can take the
                    Test</span
                  ><br />
                  <span class="info-span"
                    >*If you want the users to take the test Unlimited number of
                    times, set the Competition Frequency to Zero (0)</span
                  >
                  <b-form-spinbutton
                    id="modeque"
                    v-model="testspace.frequency"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group label="Competition Mode" v-slot="{ ariaDescribedby }">
                  <span class="info-span"
                    >*Competition Mode is to set the Mode in which the test should be
                    taken. There are two options, Full or Limited.</span
                  ><br />
                  <span class="info-span"
                    >*When Competition Mode is set to Limited, you are required to
                    choose the number</span
                  >
                  <b-form-radio
                    v-model="testspace.space_mode"
                    :aria-describedby="ariaDescribedby"
                    name="mode"
                    value="full"
                    >Full</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.space_mode"
                    :aria-describedby="ariaDescribedby"
                    name="mode"
                    value="limited"
                    >Limited</b-form-radio
                  >
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  label="Amount of questions to Limit test to"
                  label-for="testmode"
                  v-if="testspace.space_mode == 'limited'"
                >
                  <span class="info-span"
                    >*Set the amount of questions to limit test to.</span
                  ><br />
                  <span class="info-span"
                    >*This is in Per subject or Per Section Basis</span
                  >
                  <b-form-spinbutton
                    id="modeque"
                    v-model="testspace.mode_limit_question"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  label="Time in minutes to limit the test to"
                  label-for="testmode"
                  v-if="testspace.space_mode == 'limited'"
                >
                  <span class="info-span"
                    >*Set the amount of time in minutes to limit test to.</span
                  ><br />
                  <span class="info-span">*This is for the whole test</span>
                  <b-form-spinbutton
                    id="modeque"
                    v-model="testspace.mode_limit_time"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group label="Competition description" label-for="description">
                  <b-form-textarea
                    rows="5"
                    id="description"
                    v-model="testspace.description"
                    required
                  >
                  </b-form-textarea>
                </b-form-group>

                <b-form-group label="Competition Takers" label-for="takers">
                  <span class="info-span"
                    >Input all the emails of the registered Users who are
                    allowed to take this Test</span
                  ><br />
                  <span class="info-span"
                    >Ensure each email is seperated by a Comma</span
                  >
                  <b-form-tags
                    input-id="tags-separators"
                    v-model="testspace.takers"
                    separator=","
                    placeholder="Enter new emails separated by Comma"
                    class="tag-input"
                  ></b-form-tags>

                  {{ testspace.takers.length }} Emails entered
                </b-form-group>

                <b-form-group
                  label="Use Competition Wall"
                  v-slot="{ ariaDescribedby }"
                >
                  <span class="info-span"
                    >*Competition Wall prevents a User from taking the Competition before the
                    Start Date and also Prevents a User from taking the Test
                    after the End Date</span
                  ><br />
                  <span class="info-span"
                    >*When Competition Wall is used the Competition Status is set to Close
                    automatically for dates outside the Wall</span
                  >
                  <b-form-radio
                    v-model="testspace.wall"
                    :aria-describedby="ariaDescribedby"
                    name="wall"
                    value="Yes"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.wall"
                    :aria-describedby="ariaDescribedby"
                    name="wall"
                    value="No"
                    >No</b-form-radio
                  >
                </b-form-group>

                <b-form-group>
                  <p class="fll">Choose Competition Start Date</p>
                  <span class="info-span"
                    >*Competition will Open by 00:00am on the Competition Start Date
                    Chosen</span
                  >
                  <b-form-datepicker
                    v-model="testspace.startdate"
                    :min="new Date()"
                    placeholder="Choose a Date"
                    required
                  ></b-form-datepicker>
                </b-form-group>

                <b-form-group>
                  <p class="fll">Choose Competition End Date</p>
                  <span class="info-span"
                    >*Competition Will Close after the Competition End Date day has
                    elapsed</span
                  ><br />
                  <span class="info-span"
                    >*If you want Competition to span for one day only, you can make
                    Competition Start Date and Competition end Date to be the same Date</span
                  >
                  <b-form-datepicker
                    v-model="testspace.enddate"
                    :min="new Date()"
                    placeholder="Choose a Date"
                    required
                  ></b-form-datepicker>
                </b-form-group>

                <b-form-group
                  label="Allow Takers View Solution"
                  v-slot="{ ariaDescribedby }"
                >
                  <span class="info-span"
                    >*Prevent Takers from viewing solution after
                    submitting</span
                  ><br />
                  <b-form-radio
                    v-model="testspace.viewSolution"
                    :aria-describedby="ariaDescribedby"
                    name="viewsolution"
                    value="Yes"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.view_solution"
                    :aria-describedby="ariaDescribedby"
                    name="viewsolution"
                    value="No"
                    >No</b-form-radio
                  >
                </b-form-group>

                <b-form-group
                  label="Allow takers view total score"
                  v-slot="{ ariaDescribedby }"
                >
                  <span class="info-span"
                    >*Prevent takers from seeing their final score after
                    submitting</span
                  ><br />
                  <b-form-radio
                    v-model="testspace.view_score"
                    :aria-describedby="ariaDescribedby"
                    name="viewscore"
                    value="Yes"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.view_score"
                    :aria-describedby="ariaDescribedby"
                    name="viewscore"
                    value="No"
                    >No</b-form-radio
                  >
                </b-form-group>

                <div v-if="uploaded" class="alert alert-success p-3">
                  Competition Created.
                </div>

                <b-row>
                  <b-col></b-col>
                  <b-col md="6">
                    <b-form-group>
                      <b-overlay
                        :show="uploading"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=""
                      >
                        <b-button
                          :disabled="empties"
                          type="submit"
                          class="btn-sub p-1 w-100"
                          variant="success"
                        >
                          Create Competition
                        </b-button>
                      </b-overlay>
                      <b-button
                        v-if="uploading"
                        class="w-50 p-2 mt-3 btntxt"
                        variant="dark"
                        @click="stopproceed"
                      >
                        Cancel
                      </b-button>
                    </b-form-group>
                  </b-col>
                  <b-col> </b-col>
                </b-row>
              </b-form-group>
            </b-card>
          </b-overlay>
        </form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";

export default {
  data() {
    return {
      emptyin: this.empties,
      leaving: false,
      uploaded: false,
      uploading: false,
      config: "config",
      dismissCountDown: 60,
      subjectsarr: [],
      categoryarr: [],
      levelarr: [],
      coursesarr: [],
      sectionarr: [],
      scholarshiptypearr: [],
      institutionsarr: [],
      testspace: this.getForm(),
      sent: false,
      sameName: "No",
      mode: "Prototype",
      adding: false,
      getrawstring: "",
      org: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    //NProgress.start()
    store.dispatch("admin/fetchInstitutions");
    store.dispatch("admin/fetchCategories");
    store.dispatch("admin/fetchQuestions");
    store.dispatch("admin/fetchCompetitions");
    //NProgress.done()
    next();
  },

  created() {
    store.dispatch("admin/fetchInstitutions");
    store.dispatch("admin/fetchCategories");
    // let cklink = this.environ == 'development' ? "http://localhost/quicktest/plugins/ckeditor/ckeditor.js" : "https://quicktest.futavilla.com/js/ckeditor/ckeditor.js"
    // this.editorUrl = cklink

    let org = this.details.clearance_organization;
    this.testspace.organization = org;

    let inst = this.allinsti.map(x => x.name);

    // let typesarray = this.Categories.filter((x) => x.organization_name == this.details.clearance_organization).map((x) => x.name);
    if (this.Categories.length > 0) {
      let typesarr = this.Categories.map(x => x.name);
      this.categoryarr = typesarr;
    }

    this.institutionsarr = inst;
  },
  beforeRouteLeave(to, from, next) {
    this.$bvModal.show("modal-leave");

    if (this.leaving) {
      next();
    } else {
      next(false);
    }
  },

  methods: {
    chgcourses() {
      this.testspace.course = null;
      // Get the Whole Config Object of the selected Undergraduate Institution
      let levell = this.allinsti
        .filter(
          x =>
            x.category == this.testspace.category &&
            x.name == this.testspace.institution
        )
        .map(x => x.levels_config);

      let reallevell = JSON.parse(levell);

      // Get the Chosen Level exact config Array
      let config = reallevell
        .filter(x => x.name == this.testspace.level)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config[0]
        .filter(x => x.name == "courses")
        .map(x => x.values);

      // Inject this Array into the general courses Array for Selection
      this.coursesarr = courses[0];
    },

    chgsection() {
      this.testspace.section = null;
      // Get the Whole Config Object of the selected Undergraduate Institution
      let levell = this.allinsti
        .filter(
          x =>
            x.category == this.testspace.category &&
            x.name == this.testspace.institution
        )
        .map(x => x.levels_config);

      let reallevell = JSON.parse(levell);

      // Get the Chosen Level exact config Array
      let config = reallevell
        .filter(x => x.name == this.testspace.level)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let sections = config[0]
        .filter(x => x.name == "sectionsperc")
        .map(x => x.values);

      let courseindex = this.coursesarr.indexOf(this.testspace.course);
      let nsections = sections[0][courseindex];
      let sectarr = Array();

      for (let i = 0; i < nsections; i++) {
        let alpha = Array(
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K"
        );
        sectarr.push("Section " + alpha[i]);
      }

      this.sectionarr = sectarr;

      console.log(sectarr);

      // Inject this Array into the general courses Array for Selection
      //this.sectionsarr = courses[0]
    },

    leaveRoute() {
      this.leaving = true;
      this.$bvToast.toast("Press the Back Button again to Exit", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },
    stayRoute() {
      this.$bvToast.toast("Exiting Canceled", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },

    setCompetition() {
      this.setloader();

      this.createCompetition(this.testspace).then(() => {
        this.testspace.institution = null;
        this.testspace.category = null;
        this.testspace.subjects = [];
        this.testspace.level = null;
        this.testspace.course = null;
        this.testspace.section = null;
        this.testspace.frequency = 1;
        this.testspace.status = null;
        this.testspace.title = "";
        this.testspace.wall = null;
        this.testspace.startdate = "";
        this.testspace.enddate = "";
        this.uploaded = true;
        this.uploading = false;
      });
    },
    getForm() {
      return {
        organization: "",
        institution: null,
        institutionsn: "",
        institution_id: "",
        subjects: [],
        category: null,
        structure: "",
        level: null,
        course: null,
        description: "",
        frequency: 1,
        status: "Open",
        title: "",
        wall: "Yes",
        view_solution: "No",
        view_score: "No",
        takers: [],
        startdate: "",
        enddate: "",
        space_mode: "full",
        mode_limit_question: 0,
        mode_limit_time: 0,
        mode: "Prototype",
        admin: this.$store.state.loginmaster.details.fullname,
        addedbytrackid: this.$store.state.loginmaster.details.trackid
      };
    },
    chgInstitution() {
      let institution = this.allinsti.find(
        x =>
          x.category == this.testspace.category &&
          x.name == this.testspace.institution
      );
      this.testspace.institutionsn = institution.shortname;
      this.testspace.institution_id = institution.track_id;
      this.testspace.institutionsn = institution.short_name;

      this.testspace.subjects = [];
      if (this.testspace.structure == "Section") {
        let levell = this.allinsti
          .filter(
            x =>
              x.category == this.testspace.category &&
              x.name == this.testspace.institution
          )
          .map(x => x.levels_config);
        //console.log(JSON.parse(levell))
        let reallevell = JSON.parse(levell);

        this.levelarr = reallevell.map(x => x.name);
      } else {
        let subbb = this.allinsti
          .filter(
            x =>
              x.category == this.testspace.category &&
              x.name == this.testspace.institution
          )
          .map(x => x.subjects_offered);
        this.subjectsarr = JSON.parse(subbb);

        // let unparsedCompulsorySubjects = this.allinsti
        //   .filter(
        //     x =>
        //       x.category == this.testspace.category &&
        //       x.name == this.testspace.institution
        //   )
        //   .map(x => x.compulsory_subjects);
        // // Parse the Compulsory Subjects Array
        // let parsedCompulsorySubjects = JSON.parse(unparsedCompulsorySubjects);

        // let subjectsarray = JSON.parse(subbb);

        // // Loop through the Compulsory Array and perform a function for each Function
        // parsedCompulsorySubjects.forEach(subject => {
        //   // If 'all' is the value in the Compulsory subject array, then it means all the subjects are compulsory
        //   // Therefore push all the subjects in the 'subjectOptions' into the 'subject' property of the select Object
        //   if (subject.toLowerCase() == "all") {
        //     subjectsarray.forEach(subject2 => {
        //       this.testspace.subjects.push(subject2);
        //     });
        //   } else {
        //     // Push the items in the Compulsory Array one by one into the 'subject' property of the select Object
        //     this.testspace.subjects.push(subject);
        //   }
        // });
      }
    },
    chgcategory() {
      this.testspace.institution = null;
      this.org = this.details.clearance_organization;

      let inst = this.allinsti
        .filter(x => x.category == this.testspace.category)
        .map(x => x.name);
      this.institutionsarr = inst;

      this.testspace.organization = this.org;
      let tabi = this.Categories.filter(
        x => x.name == this.testspace.category
      ).map(x => x.structure);
      this.testspace.structure = tabi[0];

      let sameName = this.Categories.filter(
        x => x.name == this.testspace.category
      ).map(x => x.sameName);
      this.sameName = sameName[0];

      if (this.sameName == "Yes") {
        this.testspace.institution = this.testspace.category;

        let institution = this.allinsti.find(
          x =>
            x.name == this.testspace.category && x.organization_name == this.org
        );

        this.subjectsarr = JSON.parse(institution.subjects_offered);

        this.structure = institution.structure;

        this.testspace.institution_id = institution.track_id;
        this.testspace.institutionsn = institution.short_name;
      }
    },
    addtoArray() {
      let rawstring = this.getrawstring;
      // console.log(rawstring);
      let strarray = "";
      if (rawstring.length > 0) {
        strarray = rawstring.split(",");
      }
      // console.log(strarray)
      this.testspace.takers = strarray;
    },

    setloader() {
      this.uploading = true;
    },

    copylink() {
      var cop = document.getElementById("copier");
      cop.select();
      cop.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },
    copynow() {
      document.execCommand("copy");
    },
    stopproceed() {
      this.uploading = false; // If user clicks the cancel button, stops the spinner and enables the proceed button.
    },

    ...mapActions("admin", ["chekquestion", "createCompetition"])
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      likequestions: state => state.admin.likequestions,
      uploaded: state => state.exam.uploaded,
      allinsti: state => state.admin.listinstitutions,
      fileimage: state => state.admin.qimageurl,
      environ: state => state.loginmaster.environ,
      Categories: state => state.admin.Categories
    }),
    leav() {
      return this.leaving;
    },
    empties() {
      if (
        this.testspace.organization.length <= 0 ||
        this.testspace.institution == null ||
        this.testspace.subjects.length <= 0 ||
        this.testspace.category == null ||
        this.testspace.structure.length <= 0 ||
        this.testspace.status == null ||
        this.testspace.title.length <= 0 ||
        this.testspace.startdate.length <= 0 ||
        this.testspace.enddate <= 0 ||
        !this.substate
      ) {
        return true;
      } else {
        return false;
      }
    },
    substate() {
      if (this.testspace.structure != "Section") {
        // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
        return this.testspace.subjects.length != 0
          // this.allinsti
          //   .filter(
          //     x =>
          //       x.name == this.testspace.institution &&
          //       x.category == this.testspace.category
          //   )
          //   .map(x => x.num_courses)[0]
          ? true
          : (false && this.testspace.institution == null) || this.proceeding;
      } else {
        // Checks if all required fields has been selected
        return (
          (this.testspace.level != null && this.testspace.course != null) ||
          this.proceeding
        );
      }
    },

    numberofSubjects() {
      //returns the number of subjects required for the selected institution
      return 1;
      // this.allinsti
      //   .filter(x => x.name == this.testspace.institution)
      //   .map(x => x.num_courses)[0];
    }
  }
};
</script>

<style scoped>
.base-select {
  padding: 10px;
}

.btn-sub {
  font-size: 18px;
  font-weight: bold;
  background-color: #00984a;
  color: white;
  cursor: pointer;
}

.edicon {
  height: 150px;
}
.tag-input {
  overflow: auto;
  scrollbar-width: thin;
  max-height: 400px;
}

.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
  overflow: scroll;
}

.copyicon {
  width: 20%;
  cursor: pointer;
}

.copytext {
  width: 80%;
  overflow-y: scroll;
}

.copier {
  position: absolute;
  left: -9999px;
}
.active-method {
  background-color: rgb(8, 8, 238);
}

.inactive-method {
  background-color: rgba(128, 128, 136, 0.74);
}
.txtformat {
  font-size: 14px;
  line-height: 10px;
  white-space: nowrap;
}
.txtcode {
  overflow: auto;
}
.sqheader {
  font-size: 1.2rem;
  background-color: rgb(240, 231, 231);
  border-radius: 10px 10px;
  display: flex;
  font-weight: bold;
}
.heasub {
  width: 70%;
}

.sqicon {
  width: 30%;
  text-align: right;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 300px;
  }
}
</style>
